(function () {
  'use strict';

  const categories = {
    information: 'LANDING_PAGE_PERSONAL_ADDRESS',
    paymentSlips: 'PAYMENT_SLIPS_DESCRIPTION',
    'admail-letter': 'W2P_PRODUCT_DEFINITION_ADMAIL-LETTER_PRODUCT_NAME',
    'admail-postcard': 'W2P_PRODUCT_DEFINITION_ADMAIL-POSTCARD_PRODUCT_NAME',
    'admail-flyers': 'W2P_PRODUCT_DEFINITION_ADMAIL-FLYER',
    'admail-odr': 'LANDING_PAGE_ODR',
  };

  function orderCategory () {
    return function (val) {
      return categories[val];
    };
  }

  angular.module('web2print.shared')
    .filter('orderCategory', orderCategory);
})();
